import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { LOGOUT } from "@/utils/logout.js";
import { format_date } from '@/utils/date_formatter';
import Swal from 'sweetalert2';

export default {
  name: 'ViewSingleAsset',
  mixins: [LOGOUT],
  components: {
  },
  data() {
    return {
      asset_info: {},
      qr_code_data: {
        id: "",
        link: "",
        qr_code: "",
      },
      workflow_data: {},
    };
  },
  
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    const assetId = this.$route.params.id;
    this.fetchAssetDetails(assetId);
    this.fetchAssetWorkflow(assetId);
  },
  
  methods: {
    formatDate(date) {
      return format_date(date);
    },
    
    fetchAssetDetails(assetId) {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const GET_ASSET_URL = `${BASE_URL}/verify_api/workflow_management_api/get_asset_details_api/${assetId}/`;

      $.ajax({
        method: 'GET',
        url: GET_ASSET_URL,
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          Swal.fire({
            text: 'Loading asset details...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        },
        success: (response) => {
          if (response.status === 'success' && response.data) {
            this.asset_info = response.data;
          }
        },
        error: (error) => {
          Swal.close();
          Swal.fire({
            icon: 'error',
            text: error.responseJSON ? error.responseJSON.message : 'Failed to load asset details.',
            confirmButtonColor: '#59FF74',
          }).then(() => {
            this.$router.go(-1);
          });
        }
      });
    },
    
    fetchAssetWorkflow(assetId) {
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const GET_ASSET_WORKFLOW_URL = `${BASE_URL}/verify_api/workflow_management_api/get_asset_workflows_api/${assetId}/`;

      $.ajax({
        method: 'GET',
        url: GET_ASSET_WORKFLOW_URL,
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        success: (response) => {
          Swal.close();
          if (response.asset_workflows && response.asset_workflows.length > 0) {
            const firstWorkflow = response.asset_workflows[0];
            if (firstWorkflow.qr_code) {
              this.qr_code_data = firstWorkflow.qr_code;
            }
            if (firstWorkflow.workflow) {
              this.workflow_data = firstWorkflow.workflow;
            }
            
            // Handle production URL
            const is_production = window.location.hostname !== 'localhost';
            if (this.qr_code_data.link && is_production) {
              this.qr_code_data.link = this.qr_code_data.link.replace("http://", "https://");
            }
          }
        },
        error: (error) => {
          console.error('Failed to load asset workflow data:', error);
        }
      });
    },
    
    downloadQRCode() {
      if (!this.qr_code_data.qr_code || !this.qr_code_data.id) return;
      
      const TOKEN = localStorage.getItem('token');
      const BASE_URL = API_BASE_URL;
      const DOWNLOAD_URL = `${BASE_URL}/verify_api/workflow_management_api/download_qr_code/${this.qr_code_data.id}/`;

      Swal.fire({
        title: 'Downloading QR Code...',
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const xhr = new XMLHttpRequest();
      xhr.open('GET', DOWNLOAD_URL, true);
      xhr.setRequestHeader('Authorization', `Token ${TOKEN}`);
      xhr.responseType = 'blob';

      xhr.onload = () => {
        Swal.close();

        if (xhr.status === 200) {
          const blob = new Blob([xhr.response], { type: 'image/png' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `${this.asset_info.asset_name}_qr_code.png`.toLowerCase().replace(/\s+/g, '_');
          document.body.appendChild(link);
          link.click();

          // Cleanup
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 100);
        } else {
          Swal.fire({
            icon: 'error',
            text: 'Failed to download QR code.',
            confirmButtonText: 'OK'
          });
        }
      };

      xhr.onerror = () => {
        Swal.close();
        Swal.fire({
          icon: 'error',
          text: 'Network error occurred while downloading QR code.',
          confirmButtonText: 'OK'
        });
      };

      xhr.send();
    }
  }
};